import appMark from "@assets/images/mentor-me-app-mark.svg";
import { trans, plainTrans } from "@mongez/localization";
import { X } from "lucide-react";
import { useMobileAppBanner } from "../hooks/use-mobile-app-banner.hook";

/**
 * Slim smart-app strip rendered at the top of the sticky header on Android
 * browsers when the tenant's effective `features.mobileApp` is on.
 */
export function MobileAppBanner() {
  const { intentUrl, isVisible, dismiss, trackClick } = useMobileAppBanner();

  if (!isVisible || !intentUrl) return null;

  return (
    <aside
      aria-label={plainTrans("mobileApp.bannerLabel")}
      className="relative w-full animate-fade-in overflow-hidden bg-gradient-to-l from-violet-700 via-violet-600 to-fuchsia-500 text-white shadow-[0_8px_24px_-16px_rgba(76,29,149,0.9)]"
    >
      <div className="container mx-auto flex items-center gap-2.5 px-3 py-2 sm:px-6">
        <button
          type="button"
          onClick={dismiss}
          className="flex size-7 shrink-0 items-center justify-center rounded-full bg-white/15 text-white/90 transition hover:bg-white/25 active:scale-95"
          aria-label={plainTrans("mobileApp.dismiss")}
        >
          <X size={15} strokeWidth={2.75} />
        </button>

        <img
          src={appMark}
          alt=""
          width={40}
          height={40}
          className="size-10 shrink-0 rounded-xl shadow-md shadow-violet-950/30 ring-2 ring-white/30"
        />

        <div className="min-w-0 flex-1 leading-tight">
          <p className="truncate text-sm font-black">
            {trans("mobileApp.bannerTitle")}
          </p>
          <p className="truncate text-[11px] font-medium text-white/85">
            {trans("mobileApp.bannerSubtitle")}
          </p>
        </div>

        <a
          href={intentUrl}
          onClick={trackClick}
          className="shrink-0 whitespace-nowrap rounded-full bg-white px-3.5 py-1.5 text-xs font-black text-violet-700 shadow-md shadow-violet-950/20 transition hover:bg-violet-50 active:scale-95"
        >
          {trans("mobileApp.openApp")}
        </a>
      </div>
    </aside>
  );
}
